export const US_TIMEZONES = [
  { value: "America/New_York", label: "Eastern — America/New_York" },
  { value: "America/Chicago", label: "Central — America/Chicago" },
  { value: "America/Denver", label: "Mountain — America/Denver" },
  {
    value: "America/Phoenix",
    label: "Mountain (no DST, AZ) — America/Phoenix",
  },
  { value: "America/Los_Angeles", label: "Pacific — America/Los_Angeles" },
  { value: "America/Anchorage", label: "Alaska — America/Anchorage" },
  { value: "America/Adak", label: "Aleutian — America/Adak" },
  { value: "Pacific/Honolulu", label: "Hawaii (no DST) — Pacific/Honolulu" },
];